import script from "./SysMenuManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./SysMenuManagement.vue?vue&type=script&setup=true&lang=js"

import "./SysMenuManagement.vue?vue&type=style&index=0&id=a7000980&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7000980"]])

export default __exports__